import { render, staticRenderFns } from "./OLoaderDataComp.vue?vue&type=template&id=ffefa252&"
import script from "./OLoaderDataComp.vue?vue&type=script&lang=js&"
export * from "./OLoaderDataComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports